import React, { useState } from "react";
import { ImCross } from "react-icons/im";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";

const OrderSuccessUpdateModel = ({ handleSuccessCancel }) => {
  return (
    <>
      <div className="order_cucss_container">
        <span className="iconbox" onClick={() => handleSuccessCancel(false)}>
          <ImCross className="cross_design" />
        </span>
        <div className="ord_cus_box">
          <div className="cus_img_box">
            <IoMdCheckmarkCircleOutline className="suc_icon" />
          </div>
          <h2>SUCCESSFULL</h2>
          <h6>ORDER STATUS HAS BEEN UPDATED</h6>
        </div>
      </div>
    </>
  );
};

export default OrderSuccessUpdateModel;
